import React from 'react'
import { Helmet } from 'react-helmet'
import CreateProject from '../../components/Project/createproject-container.components'

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>AXONS PROJECT | Create Project</title>
      </Helmet>
      <CreateProject />
    </>
  )
}

export default LoginPage
